import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Triple Pixel auto-fires a "profile" event on load.
 * SPA route changes do NOT need additional TriplePixel calls.
 * This hook is kept as a no-op placeholder.
 */
export function useTripleWhalePageView() {
  const location = useLocation();

  useEffect(() => {
    // intentionally empty — Triple Pixel handles its own tracking
  }, [location.pathname]);
}
